import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CookieManagementService } from "../../account/services/cookie-management.service";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AppConfig } from '../../config-service/app.config';
import { favoriteServiceResModel } from '../models/favoriteResponse.model';
import { VersionHelper } from '../../utility-packages/versionHelper/version-helper';

@Injectable({
  providedIn: 'root'
})
export class FavoriteService {
  accessToken = '';
  sampleUserFavoritesResult: favoriteServiceResModel = { 
    result: {
      code: 33,
      cmd: '',
      message: ''
    },
    userFavorites: [{
      favId: 0,
      favorite: '0',
      description: '0',
      type: 0,
      typeDescription: '0'
    }],
    virtualCards: [{
      vCardId: 0,
      alias: '0',
      type: '0',
      typeDescription: '0'
    }]
  }  
  constructor(private http: HttpClient, private translate: TranslateService, private cookieManagementService: CookieManagementService, private versionHelper: VersionHelper) { 
  }

  public getFavoritesResult(): Observable<favoriteServiceResModel> {
    this.accessToken = this.cookieManagementService.getAccessToken();
    if(this.accessToken == ''){
      return throwError(this.translate.instant('HOME_LOGIN_ERROR'));
    } else {
      this.accessToken = "Bearer " + this.accessToken;
      let headers = new HttpHeaders({
        'Content-Type': 'application/json',
        'authorization': this.accessToken,
      });
      let url =
        AppConfig.settings.apiServer.url +
        'api/v4.0/favorite?region=' +
        AppConfig.settings.city.region +
        '&version=' +
        this.versionHelper.getVersion() +
        '&lang=' +
        AppConfig.settings.apiServer.lang +
        '&authType=' +
        AppConfig.settings.apiServer.authType;
        
      return this.http
        .get<favoriteServiceResModel>(url, {
          headers: headers,
          responseType: 'json',
        })
        .pipe(
          catchError((error) => {
            if (typeof error === 'string') {
              return throwError(error);
            } else {
              return throwError(this.translate.instant('DEFAULT_ERROR_MESSAGE'));
            }
          })
        );
    }

  }
}
